import { createBrowserHistory } from 'history'
import H from "history";

const historyReducer = (state: H.History | undefined, action: any): H.History => {

    if(state === undefined)
    {
        return createBrowserHistory();
    }
    else
    {
        return state;
    }
};

export default historyReducer;
